import { render, staticRenderFns } from "./grid-col-push-editor.vue?vue&type=template&id=570c4841&scoped=true&"
import script from "./grid-col-push-editor.vue?vue&type=script&lang=js&"
export * from "./grid-col-push-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c4841",
  null
  
)

export default component.exports